// extracted by mini-css-extract-plugin
export default {"Positions":"SimeraNavTab_Positions__xr3gb","ActiveNavItem":"SimeraNavTab_ActiveNavItem__gB-8I"};